export const STATIC_LANDING_PAGE_STATUS_OPTIONS = [
	{ name: 'All status', value: null },
	{ name: 'Active', value: 1 },
	{ name: 'Inactive', value: 0 },
];

export const STATIC_LANDING_PAGE_STATUSES = {
	1: { title: 'Active', class: 'success' },
	0: { title: 'Inactive', class: 'secondary' },
};

export const STATIC_LANDING_PAGE_TABLE_FIELDS = [
	{ key: 'id', label: 'ID' },
	{ key: 'name', label: 'Name' },
	{ key: 'isActive', label: 'Status' },
	{ key: 'action', label: '' },
];

export const STATIC_LANDING_PAGE_WIDGET_TABLE_FIELDS = [
	{ key: 'name', label: 'Name', class: 'col-name' },
	{ key: 'type', label: 'Type', class: 'col-type' },
	{ key: 'linkTo', label: 'Link To', class: 'col-link-to' },
	{ key: 'websiteVisibility', label: 'Website Visibility', class: 'col-website-visibility' },
	{ key: 'mobileVisibility', label: 'Mobile Visibility', class: 'col-mobile-visibility' },
	{ key: 'edit', label: '', class: 'col-edit' },
];

